const AFFIRMATIONS = [
  "I am worthy of love, success, and everything beautiful life has to offer.",
  "My inner beauty radiates outward and touches everyone around me.",
  "I choose to see the beauty in myself, even on difficult days.",
  "I am growing into the woman I was always meant to become.",
  "My confidence comes from within, and it is unshakeable.",
  "I release what no longer serves me and welcome what helps me bloom.",
  "I am enough, exactly as I am in this moment.",
  "My journey is unique, and I honor every step I have taken.",
  "I trust the woman I am becoming.",
  "I carry grace in my heart and strength in my spirit.",
  "Today I choose peace over perfection.",
  "I am deserving of rest, joy, and deep fulfillment.",
  "My voice matters, and I speak my truth with kindness.",
  "I give myself permission to grow at my own pace.",
  "I am surrounded by love, and I radiate love in return.",
  "Every challenge I face is shaping me into someone extraordinary.",
  "I celebrate my progress, no matter how small it feels.",
  "My beauty is not defined by others — it is defined by my heart.",
  "I forgive myself for past mistakes and embrace today with open arms.",
  "I am a woman of purpose, and my purpose is unfolding beautifully.",
  "I choose courage over comfort, and growth over fear.",
  "The world needs the light only I can bring.",
  "I nourish my mind, body, and spirit with intention and care.",
  "I am resilient, and I rise every time life asks me to.",
  "My dreams are valid, and I am capable of achieving them.",
  "I honor the woman I was, celebrate who I am, and trust who I am becoming.",
  "I attract abundance because I know I am worthy of it.",
  "My sensitivity is my superpower, not my weakness.",
  "I lead with love, and love always leads me to the right place.",
  "Today I plant seeds of kindness, confidence, and hope.",
  "I am more than my appearance — I am my character, my values, my soul.",
  "I choose to be gentle with myself as I navigate this season of life.",
  "My potential has no ceiling, and I give myself room to rise.",
  "I am learning, I am growing, and that is more than enough.",
  "I walk in grace, and grace walks with me.",
  "I release comparison and embrace my own unique path.",
  "I am a masterpiece and a work in progress at the same time.",
  "My heart is full of strength, and my mind is full of wisdom.",
  "Today I choose joy, even in the smallest moments.",
  "I am building a life that reflects my deepest values.",
  "I radiate warmth, and people feel safe in my presence.",
  "I allow myself to take up space without apology.",
  "My inner peace is not dependent on outer circumstances.",
  "I trust my instincts and honor my inner knowing.",
  "I am a source of inspiration, even when I do not realize it.",
  "Every ending is making room for a beautiful new beginning.",
  "I choose to see setbacks as setups for something greater.",
  "I am deeply connected to my purpose and passion.",
  "My self-worth is not negotiable.",
  "I am brave enough to be imperfect and beautiful because of it.",
  "I give myself the same compassion I freely give to others.",
  "I am creating a legacy of love, strength, and beauty.",
  "Today I welcome new opportunities with an open heart.",
  "I am exactly where I need to be right now.",
  "My presence is a gift, and I share it generously.",
  "I am healing, and I honor every part of that process.",
  "I stand tall in my truth and shine without dimming my light.",
  "My heart knows the way, and I follow it with trust.",
  "I release the need for approval and find peace within myself.",
  "I deserve the same love and care I pour into others.",
  "Today I focus on progress, not perfection.",
  "I am courageous, compassionate, and endlessly capable.",
  "My thoughts create my reality, and I choose empowering ones.",
  "I am surrounded by possibility, and I reach for it boldly.",
  "I honor my boundaries and protect my peace with grace.",
  "My story matters, and I tell it without shame.",
  "I am a beacon of light in this world.",
  "I treat myself as the priority I truly am.",
  "Every day I am becoming a better version of myself.",
  "I choose faith over fear in every moment.",
  "My journey toward self-love is the most important journey of my life.",
  "I am whole, I am complete, and I lack nothing essential.",
  "I bring beauty into every room I enter — not through my appearance, but through my energy.",
  "I am grateful for the woman I see in the mirror.",
  "My confidence grows stronger with every act of self-care.",
  "I release old stories that no longer reflect who I am.",
  "I am worthy of deep, genuine, unconditional love.",
  "Today I focus on what I can control and release the rest.",
  "I am proud of how far I have come.",
  "My femininity is my strength, and I embrace it fully.",
  "I am deserving of success in every area of my life.",
  "I move through life with elegance, purpose, and determination.",
  "My heart is open to receive all the good that is coming my way.",
  "I am patient with myself as I learn and grow.",
  "I choose to bloom where I am planted.",
  "My inner beauty is the foundation of everything I build.",
  "I am not defined by my past — I am defined by my choices today.",
  "I show up for myself the way I show up for the people I love.",
  "My potential is limitless, and I am just getting started.",
  "I embrace change as a pathway to my highest self.",
  "I am a woman who lifts others as she rises.",
  "Today I let go of doubt and step into my full power.",
  "I nurture my dreams with patience, love, and consistent action.",
  "I am worthy of taking time for myself without guilt.",
  "My presence makes a difference, even when I cannot see it.",
  "I am grounded, centered, and aligned with my purpose.",
  "I celebrate the beauty in others without diminishing my own.",
  "I am building a beautiful life, one intentional day at a time.",
  "My softness is not weakness — it is the greatest form of strength.",
  "I trust that everything is working out for my highest good.",
  "I am a powerful creator of the life I desire.",
  "Today I honor my emotions without letting them control me.",
  "I am worthy of joy that is deep, lasting, and real.",
  "My value does not decrease based on someone else's inability to see it.",
  "I am writing a story of resilience, beauty, and transformation.",
  "I welcome abundance in love, health, wealth, and purpose.",
  "I release perfectionism and embrace my beautifully imperfect self.",
  "My confidence is quiet, steady, and deeply rooted.",
  "I am deserving of spaces that celebrate who I am.",
  "Today I choose to be the energy I want to attract.",
  "I honor the wisdom my experiences have given me.",
  "I am courageous enough to ask for what I deserve.",
  "My light is needed in this world — I will not hide it.",
  "I am grateful for the gift of another day to grow.",
  "I treat my body with the love and respect it deserves.",
  "I am surrounded by women who inspire and uplift me.",
  "Today I choose to be kind to myself first.",
  "My happiness is my responsibility, and I embrace that power.",
  "I am allowed to change my mind, change direction, and change my life.",
  "I carry myself with dignity and warmth wherever I go.",
  "My dreams are not too big — they are exactly right for me.",
  "I am evolving, and that is the most beautiful thing about me.",
  "Today I give myself grace for the things I could not control.",
  "I am a woman of substance, depth, and incredible beauty.",
  "I celebrate my strengths and accept my areas of growth.",
  "My energy is precious, and I invest it wisely.",
  "I am magnetic, and I attract what is aligned with my soul.",
  "Today I release all that is heavy and embrace all that is light.",
  "I am deeply proud of the woman looking back at me in the mirror.",
  "My heart is brave enough to love, even after it has been hurt.",
  "I am worthy of relationships that honor and respect me.",
  "Today I step into my power with intention and grace.",
  "I nourish my spirit with gratitude, stillness, and self-love.",
  "I am capable of handling whatever life brings my way.",
  "My beauty grows deeper with every year, every lesson, every choice.",
  "I give myself permission to say no without explanation.",
  "Today I am choosing myself — fully and unapologetically.",
  "I am creating a life that feels as beautiful as it looks.",
  "My contributions to this world are meaningful and valued.",
  "I am a garden of possibilities, and today I choose to grow.",
  "Today I replace self-doubt with self-belief.",
  "I trust the timing of my life, even when it feels uncertain.",
  "I am anchored in love, and nothing can shake my foundation.",
  "My mind is a sanctuary of positive and uplifting thoughts.",
  "I am deserving of compliments, praise, and recognition.",
  "Today I focus on being present rather than being perfect.",
  "I forgive freely — not for others, but for my own peace.",
  "I am the author of my story, and I write it with intention.",
  "My inner voice is kind, supportive, and encouraging.",
  "I am a woman who knows her worth and walks in it daily.",
  "Today I embrace the beauty of simply being alive.",
  "I choose to see challenges as invitations to grow stronger.",
  "I am deserving of a life filled with meaning and purpose.",
  "My laughter, my tears, and my truth all make me beautiful.",
  "I am grateful for the simple moments that bring me joy.",
  "Today I honor my need for rest as much as my drive to succeed.",
  "I am a force of nature — gentle yet powerful, soft yet strong.",
  "My self-care is not selfish — it is the foundation of my service.",
  "I attract people and situations that elevate my life.",
  "Today I let my authentic self lead the way.",
  "I am proud of every scar, every lesson, and every triumph.",
  "My path may not be straight, but it is leading somewhere beautiful.",
  "I am a queen, and I carry my crown with humility and grace.",
  "Today I release expectations and embrace what is.",
  "I am building something beautiful that will outlast me.",
  "My kindness is a ripple that changes the world.",
  "I am not in competition with anyone — I am in communion with my purpose.",
  "Today I speak life, hope, and love into every situation.",
  "I am a woman of depth — there is always more to discover within me.",
  "My boundaries are an expression of my self-love.",
  "I welcome peace into every corner of my life.",
  "Today I take one small step toward my biggest dream.",
  "I am whole on my own and enriched by the love I share.",
  "My healing journey is sacred, and I walk it with patience.",
  "I am committed to becoming the best version of myself.",
  "Today I choose to see the good in myself and in the world.",
  "I radiate confidence, not because I am perfect, but because I am real.",
  "My presence alone can shift the energy of a room.",
  "I am deserving of a love that feels like home.",
  "Today I trust myself to make the right decisions.",
  "I am a living example of what happens when a woman believes in herself.",
  "My soul knows its worth, even when my mind forgets.",
  "I extend grace to myself in moments of uncertainty.",
  "Today I am grateful for who I am and excited about who I am becoming.",
  "I am strong enough to hold space for my own emotions.",
  "My life is a reflection of the love I pour into it.",
  "I choose to lead with empathy and walk with confidence.",
  "Today I let my heart guide me more than my fears.",
  "I am a vessel of peace, creativity, and love.",
  "My smile is a gift I share freely with the world.",
  "I give myself the space to feel, to heal, and to grow.",
  "Today I release toxic thoughts and replace them with truth.",
  "I am beautiful in my stillness and powerful in my motion.",
  "My life has purpose — even on the days I cannot see it clearly.",
  "I am surrounded by signs of love if I choose to notice them.",
  "Today I practice gratitude for the body that carries me.",
  "I am becoming more myself with every passing day.",
  "My vulnerability is not a weakness — it is a doorway to connection.",
  "I attract opportunities that align with my highest good.",
  "Today I choose to be the woman I needed when I was younger.",
  "I am healing generational wounds with every act of self-love.",
  "My story has chapters of pain, but it is a story of triumph.",
  "I am allowed to outgrow people, places, and beliefs.",
  "Today I am enough. Tomorrow I will be enough. I have always been enough.",
  "I nurture the dreams inside me like seeds in sacred soil.",
  "My life is a living testimony of grace under pressure.",
  "I carry myself with a quiet power that needs no announcement.",
  "Today I focus on my blessings, not my burdens.",
  "I am an unstoppable woman on a divine mission.",
  "My peace of mind is the greatest luxury I own.",
  "I choose to invest in experiences that feed my soul.",
  "Today I celebrate my uniqueness instead of hiding it.",
  "I am a safe space for myself — I can always come home to me.",
  "My love for myself sets the standard for how others love me.",
  "I welcome transformation — it means I am alive and growing.",
  "Today I practice speaking about myself the way I would speak about my best friend.",
  "I am more than my mistakes — I am the lessons I learned from them.",
  "My intuition is a compass, and I follow it with faith.",
  "I honor the seasons of my life — the quiet ones and the loud ones.",
  "Today I move through the world with openness and grace.",
  "I am worthy of second chances, starting with the ones I give myself.",
  "My femininity is multidimensional — it includes my softness and my fire.",
  "I am free to define beauty on my own terms.",
  "Today I am planting seeds I may not see bloom, and that is okay.",
  "I am a source of warmth and wisdom in a world that needs both.",
  "My self-worth is rooted in something far deeper than achievements.",
  "I release the pressure to have it all figured out.",
  "Today I am exactly the woman this moment needs me to be.",
  "I honor the quiet strength that lives inside me.",
  "My future is bright because I am committed to my own growth.",
  "I am a woman of faith, focus, and fierce determination.",
  "Today I take a deep breath and know that I am held.",
  "I am worthy of every dream I have ever dared to dream.",
  "My grace under pressure is something I deeply admire about myself.",
  "I give myself credit for surviving everything that tried to break me.",
  "Today I choose to carry only what serves my peace.",
  "I am surrounded by abundance, and I receive it with gratitude.",
  "My growth may be invisible to the world, but I feel it in my bones.",
  "I am the answer to prayers I may never know were spoken.",
  "Today I celebrate the courage it takes to be soft in a hard world.",
  "I am a woman who walks in her purpose with unwavering faith.",
  "My inner world is beautiful, and I tend to it with love.",
  "I give myself the freedom to be a beginner, again and again.",
  "Today I reclaim any power I ever gave away.",
  "I am learning to love the parts of me I once tried to hide.",
  "My body is a temple of grace, and I treat it as sacred.",
  "I am connected to a wisdom that runs deeper than knowledge.",
  "Today I choose to see myself through the eyes of compassion.",
  "I am a magnet for miracles, goodness, and aligned opportunities.",
  "My life does not need to look like anyone else's to be extraordinary.",
  "I practice patience with myself the way I practice it with those I love.",
  "Today I trust the process, even when I cannot see the full picture.",
  "I am becoming the woman my younger self would be so proud of.",
  "My heart is my greatest compass, and I follow it without hesitation.",
  "I choose to fill my cup first so I can pour into others from overflow.",
  "Today I let go of timelines and embrace divine timing.",
  "I am worthy of spaces that feel safe, loving, and empowering.",
  "My spirit is unbreakable, even when my heart feels tender.",
  "I am a living reminder that beauty has nothing to do with perfection.",
  "Today I step forward with faith, even if the path is unclear.",
  "I honor the work I have done on myself — it is my most important project.",
  "My laughter heals me, and I choose to laugh often and freely.",
  "I am a woman who builds bridges, not walls.",
  "Today I radiate the peace I wish to see in the world.",
  "I give thanks for the strength I did not know I had until I needed it.",
  "My worth is not measured by productivity — it is inherent and absolute.",
  "I am deserving of moments of deep rest and pure joy.",
  "Today I honor every emotion as a messenger, not an enemy.",
  "I am rooted in love, and love is the lens through which I see the world.",
  "My imperfections are not flaws — they are the fingerprints of my humanity.",
  "I am devoted to becoming a woman who leads with heart and walks with purpose.",
  "Today I remind myself: I am not behind. I am exactly on time.",
  "I release the weight of what others think and embrace my own truth.",
  "My beauty is timeless because it flows from my character.",
  "I am a woman who knows when to hold on and when to let go.",
  "Today I celebrate the quiet victories no one else sees.",
  "I am a sanctuary of peace, and I carry that sanctuary wherever I go.",
  "My life is a canvas, and I paint it with courage, love, and color.",
  "I trust that every detour is leading me to a destination even better than I planned.",
  "Today I am grateful for the lessons hidden in my struggles.",
  "I am fierce in my kindness and fearless in my compassion.",
  "My confidence does not come from knowing everything — it comes from trusting myself.",
  "I am allowed to take my time. Rushing does not equal worthiness.",
  "Today I acknowledge that I am doing the best I can, and that is beautiful.",
  "I am a woman of vision, and I bring that vision to life every day.",
  "My capacity for love — for myself and for others — is infinite.",
  "I choose peace as my power and love as my language.",
  "Today I embrace the fullness of who I am — light and shadow included.",
  "I am worthy of receiving the same energy I give to the world.",
  "My story is still being written, and the best chapters are ahead.",
  "I am grounded in gratitude and lifted by hope.",
  "Today I honor my body by moving it, nourishing it, and thanking it.",
  "I am a reflection of divine love, and I shine without effort.",
  "My tomorrow is shaped by what I believe about myself today.",
  "I stand in my truth, and my truth sets me free.",
  "Today I choose to love myself louder than my doubts.",
  "I am transforming, and transformation is always beautiful from the inside out.",
  "My gentleness with myself today creates strength for tomorrow.",
  "I am the calm in my own storm and the light in my own darkness.",
  "Today I celebrate every woman I have been and every woman I am becoming.",
  "I walk this earth with purpose, and my footsteps leave trails of hope.",
  "My inner beauty is the compass that guides my outer world.",
  "I choose to see every mirror as a reminder of how far I have come.",
  "Today I breathe deeply and remember: I am safe, I am loved, I am free.",
  "I am a woman who turns pain into power and wounds into wisdom.",
  "My peace is precious, and I protect it without apology.",
  "I deserve mornings that begin with gratitude and days filled with meaning.",
  "Today I am the living proof that beauty grows from the inside out.",
  "I greet this day with open hands and a willing heart.",
  "My courage inspires others, even when I feel afraid.",
  "I am a woman who chooses growth over comfort, always.",
  "Today I give myself the gift of stillness and reflection.",
  "I am worthy of deep rest and gentle mornings.",
  "My heart is an endless well of compassion and strength.",
  "I choose to see beauty in the ordinary moments of my life.",
  "Today I release the need to rush and embrace the rhythm of grace.",
  "I am a woman who carries hope into every room she enters.",
  "My worth is woven into who I am, not what I achieve.",
  "I honor the parts of me that are still learning to trust.",
  "Today I choose thoughts that uplift, heal, and empower me.",
  "I am allowed to dream bigger than my circumstances suggest.",
  "My resilience is a quiet fire that never goes out.",
  "I celebrate the woman who shows up, even when it is hard.",
  "Today I am grateful for every scar that taught me to shine.",
  "I am a living mosaic of every lesson, love, and loss.",
  "My grace under fire reveals the depth of my character.",
  "I choose to move gently through this world and leave it better.",
  "Today I release old guilt and step into fresh mercy.",
  "I am a woman whose value cannot be measured by any scale.",
  "My love for myself creates a ripple that heals generations.",
  "I walk in the confidence that comes from knowing who I am.",
  "Today I accept that I do not need to be understood to be valuable.",
  "I am enough — not because of what I do, but because of who I am.",
  "My heart is brave, my mind is sharp, and my spirit is free.",
  "I welcome every sunrise as a new invitation to bloom.",
  "Today I hold space for both my tears and my laughter.",
  "I am a woman of depth, warmth, and unmistakable strength.",
  "My journey is sacred, and every step has meaning.",
  "I choose to pour love into the places that hurt the most.",
  "Today I stand taller in my truth than I did yesterday.",
  "I am the kind of woman who changes everything she touches.",
  "My peace is not passive — it is a powerful choice I make daily.",
  "I release the habit of shrinking and embrace the art of expanding.",
  "Today I am grateful for my body, my breath, and my beating heart.",
  "I am a woman who finds gold in the ruins and gardens in the desert.",
  "My faith in myself grows stronger with every sunrise.",
  "I choose to be a woman who builds, heals, and inspires.",
  "Today I honor both the fire and the tenderness within me.",
  "I am proof that transformation is always possible.",
  "My legacy is being written in the way I treat myself and others.",
  "I deserve every good thing that is making its way to me.",
  "Today I let my heart lead and my fears follow far behind.",
  "I am a sanctuary of love, and I begin by loving myself.",
  "My softness and my power exist beautifully side by side.",
  "I choose to live fully, love deeply, and forgive freely.",
  "Today I celebrate the miracle of simply being me.",
  "I am a woman whose presence makes the world more beautiful.",
  "My confidence is rooted in self-knowledge, not self-perfection.",
  "I trust that the universe is conspiring in my favor.",
  "Today I step into the fullness of everything I was created to be.",
  "I am deserving of a life that overflows with purpose and joy.",
  "My story is one of rising — again and again and again.",
  "I am the author, the heroine, and the legacy of my own beautiful life.",
  "Today I remember: I was born to bloom, and nothing can stop that.",
  "I close this day knowing I am loved, I am worthy, and I am becoming.",
];

export default AFFIRMATIONS;
